import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import RoleSkillSelect from 'components/Shared/RoleSkillSelect';
import styles from './PostSelectRole.module.scss';

class PostSelectRole extends Component {
  static propTypes = {
    availableRoles: PropTypes.array,
    autoSelectedRole: PropTypes.bool,
    currentRole: PropTypes.any,
    loadingAvailableRoles: PropTypes.bool,
    onChangeRole: PropTypes.func,
    handleNext: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      hasTriedToContinue: false,
    };
    this.handleContinueClick = this.handleContinueClick.bind(this);
  }

  handleContinueClick = () => {
    handleNext();
  };

  render() {
    const { availableRoles, currentRole, loadingAvailableRoles, onChangeRole } =
      this.props;
    return (
      <div id="post-brief-select-role" className={styles.postSelectRoleForm}>
        <div>
          <p className="mb fs-15 lato-bold">Enter what you need:</p>
        </div>
        <div>
          <RoleSkillSelect
            roles={availableRoles}
            loadingRoles={loadingAvailableRoles}
            value={currentRole}
            onValueChange={onChangeRole}
            className={styles.simpleSelect}
            placeholder="Type a freelance role"
          />
          <div className={styles.categories}>
            <p className="fs-15">Most popular freelance roles:</p>
            <a
              href="/post/Animator"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              Animator
            </a>
            ,&nbsp;
            <a
              href="/post/Actor"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              actor
            </a>
            ,&nbsp;
            <a
              href="/post/Graphic%20Designer"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              graphic designer
            </a>
            ,&nbsp;
            <a
              href="/post/Illustrator"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              illustrator
            </a>
            ,&nbsp;
            <a
              href="/post/Music%20Composer"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              music composer
            </a>
            ,&nbsp;
            <a
              href="/post/UI%20Designer"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              UI designer
            </a>
            ,&nbsp;
            <a
              href="/post/Videographer"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              videographer
            </a>
            ,&nbsp;
            <a
              href="/post/Vocalist"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              vocalist
            </a>
            ,&nbsp;
            <a
              href="/post/Web%20Designer"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              web designer
            </a>
            ,&nbsp;
            <a
              href="/post/Web%20Developer"
              onClick={() => {
                window.onbeforeunload = null;
              }}
            >
              web developer
            </a>
            &nbsp;(+
            <Link to="/hire-a-freelancer" id="post-brief-browse-categories">
              240 more
            </Link>
            ).
          </div>
        </div>
      </div>
    );
  }
}

export default PostSelectRole;
